export default "__VITE_ASSET__BROkTwaY__"